module.exports = __webpack_public_path__ + "media/images/logo-cf7efee59f1aa3e61f8c3db7b76fb8b5.png";